<template>
  <div class="content">
    <div class="menu">
      <div class="menu-con">
        <div class="menu-con-box" style="margin-bottom: 1.12vw" v-for="(data,index) in item" :key="index" @click="changeBgc(index)">
          <div class="menu-con-list menu-con-top" v-if="index === 0">
            <div class="menu-con-top-icon" :class="{'active-top':data.sign === 1}">
              <a>{{data.text}}</a>
            </div>
          </div>
          <div class="menu-con-list menu-con-bottom" v-if="index !== 0"> 
            <el-badge :value="data.valueNum" :max="99" class="item">
              <div class="menu-con-bottom-icon" :class="{'active-bottom':data.sign === 1}">
                <a>{{data.text}}</a>
              </div>
            </el-badge>
          </div>
        </div>
      </div>
      <img class="menu-icon" src="../../assets/box-3.png"/>
    </div>
    <div class="matter">
      <transition name="slide-fade">
        <router-view class="Router"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import {searchWarningAndTaskIsDeal} from '../../api/login'
export default {
  name: 'Maintenance',
  data () {
    return {
      item: [
        {text: '智慧养护', sign: 1, path: '/maintenance'},
        {text: '包芯监控', sign: 0, path: '/core'},
        {text: '垛内监控', sign: 0, path: '/crib'},
        {text: '仓间监控', sign: 0, path: '/warehouse'},
        {text: '虫情监控', sign: 0, path: '/plant'},
        {text: '质检管理', sign: 0, path: '/quality'},
	    	{text: '养护评吸', sign: 0, path: '/pinxi'},
        {text: '预警管理', sign: 0, path: '/warn', valueNum: ''},
        {text: '养护计划', sign: 0, path: '/conserve'},
        {text: '损耗统计', sign: 0, path: '/loss'},
        {text: '任务中心', sign: 0, path: '/task', valueNum: ''},
        {text: '数据报表', sign: 0, path: '/report'},
         {text: '历史数据', sign: 0, path: '/historyData'}
      ]
    }
  },
  created () {
    let index = parseInt(this.$route.query.index)
    this.item.map((data, ind) => {
      if (index === ind) {
        data.sign = 1
      } else {
        data.sign = 0
      }
    })
    if (isNaN(index)) {
      this.item[0].sign = 1
    }
    this.getTasksDealNum()
  },
  watch: {
    '$route' () {
      let index = parseInt(this.$route.query.index)
      this.item.map((data, ind) => {
        data.sign = 0
        if (index === ind) {
          data.sign = 1
        }
      })
      if (isNaN(index)) {
        this.item[0].sign = 1
      }
    }
  },
  methods: {
    changeBgc: function (index) {
      console.log(index)
      let _this = this
      _this.item.map((data, ind) => {
        data.sign = 0
        if (index === ind) {
          _this.$router.push({
            path: data.path,
            query: {
              index: index
            }
          })
        }
      })
      _this.item[index].sign = 1
    },
    getTasksDealNum: function () {
      searchWarningAndTaskIsDeal().then(res => {
        if (res.data.taskIsDealNum > 0) {
          this.item[10].valueNum = res.data.taskIsDealNum
        }
        if (res.data.warningIsDealNum > 0) {
          this.item[7].valueNum = res.data.warningIsDealNum
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
@import "./Maintenance.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/Maintenance.vue